<template>
  <el-row :gutter="20" class="sec_box d2-mt-10" v-loading="loading">
    <el-button v-if="checked.name=='我的发布'" class="d2-ml-10 d2-m-5 publish_btn" type="primary" icon="el-icon-plus"
        @click="publistHandle">我要发布</el-button>
    <template v-if="ListData.length != 0">
      <el-col :span="24" v-for="(item, index) in ListData" :key="index" class="list_item_box" :title="item.Title">
        <i class="el-icon-chat-dot-square" style="font-size:25px;color:#1677fc"></i>
        <div class="list_item_info" @click="listDetialHandle(item)">
          <p class="list_item_title">{{ item.Subject || item.Title || "-" }}</p>
          <div class="list_item_content">{{ item.Content || '评论：'+item.Comment }}</div>
          <div class="list_item_time d2-mt-5">
            <span>{{ item.CreateTime || "-" }}</span>
            <p class="list_item_time_icon">
              <span>
                <d2-icon name="commenting-o" class="d2-mr-5" />{{item.CommentCount}}</span>
              <template v-if="!item.AgreeType && item.AgreeType!=false">
                <span>
                  <d2-icon :name="item.tempAgreeType == 1 ? 'heart' : 'heart-o'" class="d2-mr-5" />
                  {{item.AgreeCount}}</span>
              </template>
              <template v-else>
                <span>
                  <d2-icon :name="item.AgreeType == 1 ? 'heart' : 'heart-o'" class="d2-mr-5" />
                  {{item.AgreeCount}}</span>
              </template>
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty class="auto"></el-empty>
    </template>
    <edit-publish :publish='publish' v-model="editPublishVisible" @submit='getPublishData' />
  </el-row>
</template>

<script>
  import editPublish from "./editPublish";
  import * as indexService from "@/api/sys/index";
  export default {
    name: "listComment",
    components: {
      editPublish,
    },
    data() {
      return {
        editPublishVisible: false,
        publish: {}
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {},
    mounted() {},
    watch: {
      checked(val) {
        // console.log(val)
      }
    },
    methods: {
      listDetialHandle(item) {
        if (this.checked.name == '我的发布') {
          this.$router.push({
            path: "webView",
            query: {
              code: "comment",
              shortTitle: "职代会热点",
              detailed: false,
              dataId: item.ID,
              fiter: "",
              routeFrom:this.checked.name
            },
          });
        }
        // let query = {
        //   dataId: item.ID,
        //   detailed: false,
        //   fiter: "",
        //   shortTitle: ""
        // }
        // indexService.GetMsgData(query).then((data) => {
        //   this.dialogVisible = true;
        //   this.messageDetial = data.data.mainData
        //   this.type = item.Category
        // }).catch((e) => {
        //   this.$message.error(e.message);
        //   this.dialogVisible = false;
        // });
      },
      publistHandle() {
        this.editPublishVisible = true;
        this.publish = {}
      },
      getPublishData() {
        this.$emit('message')
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  .list_item_content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list_item_time {
    display: flex;
  }

  .list_item_time_icon {
    flex: 1;
    margin: 0;
    text-align: right;
  }

  .list_item_time_icon span {
    margin-left: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }
</style>